import React, { useState } from 'react';
import { Box, Button, Dialog, TextField, Typography } from '@mui/material';
import { fieldSx, pillButtonSx, vb } from './theme';

// "Improve with AI" prompt for one section/scene (optional instruction).
const ImproveDialog: React.FC<{
  open: boolean;
  title: string;
  busy: boolean;
  onClose: () => void;
  onSubmit: (instruction: string | null) => void;
}> = ({ open, title, busy, onClose, onSubmit }) => {
  const [text, setText] = useState('');
  return (
    <Dialog
      open={open}
      onClose={busy ? undefined : onClose}
      PaperProps={{
        sx: {
          background: vb.surface,
          border: `1px solid ${vb.border}`,
          borderRadius: '12px',
          p: 2.5,
          width: 520,
          maxWidth: '92vw'
        }
      }}
    >
      <Typography sx={{ fontFamily: vb.font, fontSize: 16, fontWeight: 800, color: vb.text, mb: 0.5 }}>
        {title}
      </Typography>
      <Typography sx={{ fontFamily: vb.font, fontSize: 13, color: vb.textSecondary, mb: 1.5 }}>
        Optional: tell Elliott what to change. Leave empty for a general improvement. The result must still fit the
        video length.
      </Typography>
      <TextField
        multiline
        minRows={3}
        fullWidth
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="e.g. Make it punchier and add a quick example"
        inputProps={{ 'aria-label': 'Improvement instruction', maxLength: 1000, 'data-testid': 'improve-input' }}
        sx={fieldSx}
      />
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 2 }}>
        <Button onClick={onClose} disabled={busy} sx={pillButtonSx()}>
          Cancel
        </Button>
        <Button
          data-testid="improve-submit"
          onClick={() => onSubmit(text.trim() || null)}
          disabled={busy}
          sx={pillButtonSx(true)}
        >
          {busy ? 'Improving...' : 'Improve'}
        </Button>
      </Box>
    </Dialog>
  );
};

export default ImproveDialog;
